import React from 'react';
import styled from 'styled-components';
import doctorOfficePhoto from '../assets/DrRogersOffice.png';

const AboutPageContainer = styled.div``;

const ContentSection = styled.section`
  max-width: 1100px;
  margin: 4rem auto;
  padding: 0 2rem;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
  color: #333;
  text-align: center;
`;

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4rem;

  @media (max-width: 992px) {
    flex-direction: column;
    gap: 2rem;
  }
`;

const TextContent = styled.div`
  flex: 1;
`;

const Paragraph = styled.p`
  font-size: 1.1rem;
  line-height: 1.8;
  color: #555;
`;

const ImageWrapper = styled.div`
  flex: 0 0 350px;
  max-width: 350px;

  @media (max-width: 992px) {
    max-width: 280px;
  }
`;

const DoctorImage = styled.img`
  width: 100%;
  display: block;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border: 5px solid white;
`;

const About = () => {
  return (
    <AboutPageContainer>
      <ContentSection>
        <Title>About Us</Title>
        <ContentWrapper>
          <TextContent>
            <Paragraph>
              We are fully qualified UK based doctors, who wish to remove the wait for private letters from the GP, providing you with the advice and support you need quickly and effectively, exactly when you need it. This will ease the pressure on the NHS, while also providing you with a quick and professional service.
            </Paragraph>
          </TextContent>
          <ImageWrapper>
            <DoctorImage src={doctorOfficePhoto} alt="Dr. Mathew Rogers" />
          </ImageWrapper>
        </ContentWrapper>
      </ContentSection>
    </AboutPageContainer>
  );
};

export default About;
